export default "__VITE_ASSET__LfqZSjZQ__"